import { AsyncHelper } from "js/tools/async.helper.js";

const asyncHelper = AsyncHelper();

const getInitialData = async (config) => {
  const { data: initialData } = await asyncHelper.getUrl(config.getApiUrl());
  let { filters, results } = getRelevantSearchData(initialData);
  return { filters, results };
};

const getSearchResults = async (config, userFormData = {}) => {
  const productType = window.ortus.productType ?? "electricity";
  const baseFormData = {
    productType: productType,
    resultsOnly: false,
    pageSize: 10,
    page: 1,
    benchmark: 1,
  };

  const formData = { ...baseFormData, ...userFormData };

  const { data: searchData } = await asyncHelper.postUrl(
    `${config.getApiUrl()}calculator/energy`,
    formData
  );

  return getRelevantSearchData(searchData);
};
const getRelevantSearchData = (apiData) => {
  const filters = apiData?.filters;
  const results = apiData?.offers;
  const benchmarkTariff = apiData?.benchmarkTariff;
  return { filters, results, benchmarkTariff };
};
const getPackageDetails = async (packageUrl) => {
  const packageDetails = await asyncHelper.getUrl(packageUrl);

  return packageDetails;
};

export { getSearchResults, getPackageDetails, getInitialData };
